import { render, staticRenderFns } from "./CliD_Receivables.vue?vue&type=template&id=1de24353"
import script from "./CliD_Receivables.vue?vue&type=script&lang=js"
export * from "./CliD_Receivables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports